import * as React from "react";
import { HigherContrastToggleButtonGroup } from "./ResultsViewToggle";
import ToggleButton from "@mui/material/ToggleButton";
import { useState } from "react";
import { useLanguage } from "./Language";
import Stack from "@mui/material/Stack";
import CheckIcon from "@mui/icons-material/Check";

export const PROHIBITED_LIST_TYPE = "prohibitedListType";
export const CONFIG_LIST_TYPE = "configListType";
export const PERSONAL_LIST_TYPE = "personalListType";

type listType = "prohibitedListType" | "configListType" | "personalListType";

interface ListTypeToggleProps {
  isGuardian: boolean;
  isConfigAdmin: boolean;
  defaultValue: listType;
  onChange: (event: React.MouseEvent<HTMLElement>, newValue: listType) => void;
}

export const ListTypeToggle: React.FC<ListTypeToggleProps> = (props) => {
  const [value, setValue] = useState<listType>(props.defaultValue);
  const { translate } = useLanguage();

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: listType | null
  ) => {
    // don't allow deselection
    if (newValue != null) {
      setValue(newValue);
      if (props.onChange) {
        props.onChange(event, newValue);
      }
    }
  };

  // TODO translate aria-label
  return (
    <HigherContrastToggleButtonGroup
      color="secondary"
      value={value}
      onChange={handleChange}
      exclusive
      size="small"
      aria-label="List Type"
    >
      {props.isGuardian && (
        <ToggleButton
          autoFocus={value === PROHIBITED_LIST_TYPE}
          value={PROHIBITED_LIST_TYPE}
          sx={{ pr: "12px", pl: "12px" }}
        >
          <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
            {value === PROHIBITED_LIST_TYPE && <CheckIcon />}
            {translate("prohibited")}
          </Stack>
        </ToggleButton>
      )}
      {props.isConfigAdmin && (
        <ToggleButton
          value={CONFIG_LIST_TYPE}
          autoFocus={value === CONFIG_LIST_TYPE}
          sx={{ pr: "12px", pl: "12px" }}
        >
          <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
            {value === CONFIG_LIST_TYPE && <CheckIcon />}
            {translate("config")}
          </Stack>
        </ToggleButton>
      )}

      <ToggleButton
        value={PERSONAL_LIST_TYPE}
        autoFocus={value === PERSONAL_LIST_TYPE}
        sx={{ pr: "12px", pl: "12px" }}
      >
        <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
          {value === PERSONAL_LIST_TYPE && <CheckIcon />}
          {translate("personal")}
        </Stack>
      </ToggleButton>
    </HigherContrastToggleButtonGroup>
  );
};
